import React from "react";
import PropTypes from "prop-types";
import { Accordion, AccordionTab, Heading, IconBusiness, IconAgent } from '@lmig/lmds-react';
import { Maps } from '../Google/DynamicExports';
import WrapperSizeable from "../Utility/WrapperSizeable";
import AgentListCard from "../Agent/AgentListCard";
import { OfficeCard } from "../OfficesByState";

const FindAnAgentResults = ({
  agents = [],
  offices = [],
  bothAgentOffice = true,
  query
}) => {
  const markers = offices.reduce((acc, val) => {
    if (val.location) {
      acc.push({
        name: `${val.address.city}, ${val.address.state.code}`,
        lat: val.location.coordinates[1],
        lng: val.location.coordinates[0],
        address: val.address,
        alias: val.aliasPath,
        phone: val.phones?.primary?.number,
      });
    }

    return acc;
  }, []);

  const officeMap = offices.map(({ alias }, index) => ({ alias, index }));

  return (
    <WrapperSizeable margin={0} id="findAgentResults">
      {bothAgentOffice && agents.length > 0 && offices.length > 0 &&
        <div className="resultsWithMap">
          <div className="officeAgentResults">
            <Heading type="h3-bold" className="resultsHeading">{`All search results (${agents.length + offices.length})`}</Heading>
            <Accordion className="tabbedResults">
              <AccordionTab icon={<IconBusiness />} labelVisual={offices.length === 1 ? `Offices (1 result)` : `Offices (${offices.length} results)`}>
                <div className="resultsWrapper">
                  {offices.map(({ address, phones, rating, reviewCount, dailyHours, alias, distanceAway }, index) => <OfficeCard address={address} phones={phones} rating={rating} reviewCount={reviewCount} dailyHours={dailyHours} alias={alias} shadow key={alias} agentLink getDirections pin={distanceAway && { index, distanceAway }} />)}
                </div>
              </AccordionTab>
              <AccordionTab icon={<IconAgent />} labelVisual={agents.length === 1 ? `Agents (1 result)` : `Agents (${agents.length} results)`} active>
                <div className="resultsWrapper">
                  {agents.map((agent) => {
                    const officeAlias = agent.aliasPath.split('/')[2];
                    const officeIndex = officeMap.find(office => office.alias === officeAlias);

                    return (<AgentListCard agent={agent} key={agent?.displayName} pin={officeIndex && { index: officeIndex.index, distanceAway: agent.distanceAway }} />);
                  }
                  )}
                </div>
              </AccordionTab>
            </Accordion>
          </div>
          <div className="horizontalMapWrap">
            <div className="mapWrapper">
              <Maps height="50vh" markers={markers} />
            </div>
          </div>
        </div>}
      {!bothAgentOffice && agents.length > 0 && offices.length === 0 &&
        <div>
          <Heading type="h3-bold" className="resultsHeading">{`All search results (${agents.length})`}</Heading>
          <div className="agentsResults">
            {agents.map((agent) => <AgentListCard agent={agent} key={agent?.displayName} />)}
          </div>
        </div>}
      {agents.length === 0 && offices.length === 0 && <div className="noResults">
        Your search <strong>{`"${query}"`}</strong> did not match any results.
      </div>}
      <style global jsx>{`@import './FindAnAgentResults.scoped.scss';`}</style>
    </WrapperSizeable>
  );
};

FindAnAgentResults.propTypes = {
  agents: PropTypes.array,
  offices: PropTypes.array,
  bothAgentOffice: PropTypes.bool,
  query: PropTypes.string,
};

export default FindAnAgentResults;